/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-27 19:00:02
 */

import * as request from '@/utils/request'

export default {
  /**
   * getCompanyList
   * @description 公司管理列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getCompanyList(data) {
    return request.post('/company/list', data)
  },
  /**
   * saveCategory
   * @description 保存公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveCompany(data) {
    return request.post('/company/store', data)
  },
  /**
   * getCategoryInfo
   * @description 获取公司详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getCompanyInfo(id) {
    let data = {id:id}
    return request.post('/company/get_info', data)
  },
  /**
   * deleteCategoryInfo
   * @description 删除公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteCompany(id) {
    let data = {id:id}
    return request.post('/company/delete', data)
  },
  /**
   * @description 分类排序
   * @author YM
   * @date 2019-03-07
   * @param {*} ids
   * @returns
   */
  orderCompany(ids) {
    let data = {ids:ids}
    return request.post('/company/order',data)
  },
  /**
   * @description 获取公司分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getCompanyCategoryList() {
    return request.post('/company/category_list')
  },
  /**
   * @description 获取公司分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
  */
  getCompanySubCategoryList(id) {
    let data = {id:id}
    return request.post('/company/sub_category_list', data)
  },
  /**
   * @description 设置税率
   * @author YM
   * @date 2019-03-04
   * @returns
  */
  getRate(company_id, rate) {
    let data = {
      company_id: company_id,
      rate: rate
    }
    return request.post('/company/save_rate', data)
  },
  /**
   * @description 创建子账户
   * @author YM
   * @date 2019-03-04
   * @returns
  */
  createSubAccount(company_id, company_name, channel_account,acct_type,in_bank_code,in_bank_no,in_bank_name) {
    let data = {
      company_id,
      company_name,
      channel_account,
      acct_type,
      in_bank_code,
      in_bank_no,
      in_bank_name
    }
    return request.post('/company/create_mainaccount', data)
  },
  /**
   * @description 测试服务充值
   * @author YM
   * @date 2019-03-04
   * @returns
  */
 createRecharge(money, channel_account, company_id) {
  let data = {
    money,
    channel_account,
    company_id
  }
  return request.post('/company/create_recharge', data)
 },
 /**
   * @description 获取短信模版数据
   * @author YM
   * @date 2019-03-04
   * @returns
  */
 getSmsTemplate(data) {
  return request.post('/company/get_sms_template', data)
 },
 /**
   * @description 获取银行编码
   * @author YM
   * @date 2019-03-04
   * @returns
  */
 getBankCode() {
  return request.post('/bank_code/list', null)
 }
 
}